import * as React from 'react';

import { TeamRole } from '@showbie-socrative/socrative-utils';

import { roleNamesAndDescriptions } from '~teacher/components/Account/TeamMembers/TeamMembersTable/RoleActionMenu/roleNamesAndDescriptions'; // This isn't actually a menu, but static text. It's just called a menu to make the file names consistent. ¯\_(ツ)_/¯

interface Props {
  targetMemberRole: TeamRole;
}

// Show the Role name, not actually a menu.
export function StaticRoleName({ targetMemberRole }: Props) {
  return (
    <div className="flex items-center content-center gap-1 h-full role-action-menu">
      <span className="capitalize">
        {roleNamesAndDescriptions[targetMemberRole]?.title}
      </span>
    </div>
  );
}
